import Vue from 'vue';
import './plugins/vuetify';
import App from './App.vue';
import Toasted from 'vue-toasted';
import * as VueGoogleMaps from "vue2-google-maps";

export const bus = new Vue(); //event bus

Vue.config.productionTip = false;

Vue.use(Toasted);

Vue.use(VueGoogleMaps, {
  load: {
    key: "AIzaSyCCLCh0dX81ASRsu9OcFkWI__iMxcgaESg",
    libraries: "places" // necessary for places input
  }
});

new Vue({
  render: h => h(App),
}).$mount('#app')
